import { render, staticRenderFns } from "./MedicalRequirementsPlanFloatBtns.vue?vue&type=template&id=f196d850&"
import script from "./MedicalRequirementsPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports